// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"f3ffa833","3874":"fd58b89e","4183":"c0258b76"}[chunkId] + ".chunk.css";
};